interface EditConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function EditConfirmModal({ isOpen, onClose, onConfirm }: EditConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[60] p-4">
      <div className="bg-gradient-to-br from-[#2A1F3D] to-[#1E1A30] rounded-2xl max-w-sm w-full border border-yellow-500/30 shadow-2xl shadow-yellow-500/20">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-yellow-500/20 flex items-center justify-center">
              <span className="text-2xl">⚠️</span>
            </div>
            <h3 className="text-lg font-bold text-white">编辑确认</h3>
          </div>
          <p className="text-avalon-text text-sm mb-6">
            确定要编辑这条历史记录吗？
          </p>
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 py-3 rounded-lg bg-avalon-card text-white font-medium hover:bg-avalon-purple/50 transition-colors"
            >
              取消
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 py-3 rounded-lg bg-yellow-500 text-white font-medium hover:bg-yellow-600 transition-colors"
            >
              确定编辑
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
